import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { MediasZipResponse } from 'src/dto/dam/media-dto';
import { ModalService } from 'src/services/other/modal.service';

@Component({
  selector: 'app-modal-operation-completed',
  templateUrl: './modal-operation-completed.component.html',
  styleUrls: ['./modal-operation-completed.component.css']
})
export class ModalOperationCompletedComponent {

  confirmationMessage: string = '';
  information: MediasZipResponse = new MediasZipResponse();

  isLoading: boolean = false;
  isSuccess: boolean = false;
  isError: boolean = false;
  isErrorCustom: boolean = false;
  isConfirmationVisible: boolean = false;
  isOperationVisible: boolean = false;
  isCustomMessageVisible: boolean = false;
  private isShowButtonConfirm: boolean = false;

  private isSuccessSubscription: Subscription;
  private isErrorSubscription: Subscription;
  private isLoadingSubscription: Subscription;

  constructor(private modalService: ModalService) {
    this.isSuccessSubscription = this.modalService.isSuccess$.subscribe((success) => {
      this.isSuccess = success;
    });

    this.isLoadingSubscription = this.modalService.isLoading$.subscribe((loading) => {
      this.isLoading = loading;
    });

    this.isErrorSubscription = this.modalService.isError$.subscribe((error) => {
      this.isError = error;
    });

  }

  ngOnDestroy() {
    this.isSuccessSubscription.unsubscribe();
    this.isErrorSubscription.unsubscribe();
    this.isLoadingSubscription.unsubscribe();
  }

 

  ngOnInit() {
    this.modalService.isVisible$.subscribe((isVisible) => {
      this.isConfirmationVisible = isVisible;
    });
    this.modalService.isConfirmation$.subscribe((isVisible) => {
      this.isOperationVisible = isVisible;
    });

    this.modalService.isConfirmationCustom$.subscribe((isVisible) => {
      this.isCustomMessageVisible = isVisible;
    });

    this.modalService.isErrorCustom$.subscribe((isVisible) => {
      this.isErrorCustom = isVisible;
    });

    this.modalService.message$.subscribe((message) => {
      this.confirmationMessage = message;
    });

    this.modalService.information$.subscribe((information) => {
      this.information = information;
    });

    this.modalService.showButton$.subscribe((isVisible) => {
      this.isShowButtonConfirm = isVisible;
    })
  }

  confirmButton(){
    this.modalService.executeConfirm();
  }
  
  cancelButton(){
    this.modalService.executeReject();
  }


}
